// Module
var code = `<div class="ps-backdrop"></div>
<div class="ps-panel">
  <div class="ps-header">
    <span class="ps-title">Pipeline Sandbox</span>
    <div class="header-actions">
      <div class="ps-namespace-selector" id="ps-namespace-selector">
        <label class="ps-namespace-label" title="Active sandbox namespace — scopes schema editing, telemetry reads and pipeline filtering.">NS:</label>
        <hs-help-icon key="pipeline.namespace"></hs-help-icon>
        <button id="ps-namespace-btn" class="ps-namespace-btn" title="Change namespace">
          <span id="ps-namespace-current">—</span>
          <span class="ps-namespace-caret">▾</span>
        </button>
      </div>
      <span id="ps-status" class="ps-status"></span>
      <button id="ps-concepts-btn" class="btn btn-sm" title="Browse concept help">📘 Concepts</button>
      <button id="ps-theme-toggle-btn" class="btn btn-icon" title="Toggle light/dark theme">🌙</button>
      <button id="ps-close-btn" class="btn btn-icon" title="Close">✕</button>
    </div>
  </div>

  <div class="ps-body">
    <!-- Pipeline List View -->
    <div id="ps-list-view" class="ps-view">
      <div class="ps-toolbar">
        <hs-toolbar-button id="ps-create-btn" title="Create Pipeline"></hs-toolbar-button>
        <hs-toolbar-button id="ps-ml-models-btn" title="ML Models"></hs-toolbar-button>
        <hs-toolbar-button id="ps-ml-labeling-btn" title="Labeling"></hs-toolbar-button>
        <hs-toolbar-button id="ps-plugins-btn" title="Plugins"></hs-toolbar-button>
        <hs-toolbar-button id="ps-schema-explorer-btn" title="Schemas"></hs-toolbar-button>
        <hs-toolbar-button id="ps-topology-btn" title="Topology"></hs-toolbar-button>
        <hs-toolbar-button id="ps-prepare-pr-btn" title="Prepare PR"></hs-toolbar-button>
        <hs-toolbar-button id="ps-bundle-btn" title="Feature Bundle"></hs-toolbar-button>
        <hs-toolbar-button id="ps-refresh-btn" class="ps-icon-btn" title="↻"></hs-toolbar-button>
      </div>
      <div id="ps-pipeline-table" class="ps-pipeline-table">
        <div class="ps-empty-state">Loading pipelines...</div>
      </div>
    </div>

    <!-- ML Model Management (mounted on demand) -->
    <div id="ps-ml-models-view" class="ps-view hidden"></div>

    <!-- ML Labeling Queue (mounted on demand) -->
    <div id="ps-ml-labeling-view" class="ps-view hidden"></div>

    <!-- Pipeline Detail / Log Viewer (shown when a pipeline is selected) -->
    <div id="ps-detail-view" class="ps-view hidden">
      <div class="ps-detail-header">
        <button id="ps-back-btn" class="btn btn-icon" title="Back to list">← Back</button>
        <span id="ps-detail-name" class="ps-detail-name"></span>
        <span id="ps-detail-state" class="ps-state-badge"></span>
        <span id="ps-detail-sandbox-badge" class="ps-sandbox-badge hidden"></span>
        <span id="ps-detail-feature-badge" class="ps-feature-badge hidden" title=""></span>
        <div class="ps-detail-actions" id="ps-detail-explain-actions">
          <button type="button" id="ps-detail-explain-pipeline-btn" class="btn btn-sm hidden" title="Walk through what this pipeline does, step by step">🔎 Walkthrough</button>
          <button type="button" id="ps-detail-explain-concurrency-btn" class="btn btn-sm hidden" title="Explain concurrency & back-pressure for this pipeline">🔎 Concurrency</button>
        </div>
        <div class="ps-detail-actions" id="ps-detail-actions"></div>
      </div>
      <div id="ps-detail-problems" class="ps-detail-problems hidden"></div>
      <div class="ps-detail-body">
        <div class="ps-detail-tabs">
          <button class="ps-tab active" data-tab="logs">Logs</button>
          <button class="ps-tab" data-tab="stats">Stats</button>
          <button class="ps-tab" data-tab="config">Config</button>
          <button class="ps-tab" data-tab="test">Test</button>
          <button class="ps-tab" data-tab="evidence">Evidence</button>
        </div>
        <div id="ps-tab-logs" class="ps-tab-panel active">
          <div class="ps-logs-layout">
            <div class="ps-logs-main">
              <div class="ps-log-toolbar">
                <div class="ps-log-filters">
                  <hs-checkbox-toggle data-level="error" checked label="error"></hs-checkbox-toggle>
                  <hs-checkbox-toggle data-level="warn" checked label="warn"></hs-checkbox-toggle>
                  <hs-checkbox-toggle data-level="info" checked label="info"></hs-checkbox-toggle>
                  <hs-checkbox-toggle data-level="debug" checked label="debug"></hs-checkbox-toggle>
                  <hs-checkbox-toggle data-level="verbose" checked label="verbose"></hs-checkbox-toggle>
                </div>
                <span id="ps-log-count" class="ps-log-count">0 lines</span>
                <label class="ps-log-limit-label" title="Lines retained per pipeline when you navigate away (10-1000)">Keep
                  <input type="number" id="ps-log-limit" class="ps-input ps-input-sm ps-log-limit" min="10" max="1000" step="10" value="100" />
                </label>
                <button id="ps-log-pretty-btn" class="btn btn-sm ps-toggle-on" title="Toggle JSON pretty-print">Pretty</button>
                <button id="ps-log-pause-btn" class="btn btn-sm" title="Freeze log display">Freeze</button>
                <button id="ps-log-clear-btn" class="btn btn-sm" title="Clear log buffer">Clear</button>
                <button id="ps-telemetry-drawer-toggle" class="btn btn-sm" title="Toggle telemetry drawer">Telemetry ▸</button>
              </div>
              <div class="ps-log-test-bar">
                <button type="button" id="ps-log-test-select" class="ps-input ps-input-sm ps-picker-display" title="Click to change"><em>(select test case)</em></button>
                <input type="hidden" id="ps-log-test-name" value="" />
                <button id="ps-log-test-run" class="btn btn-sm btn-primary" title="Send test payload and observe logs">▶ Test</button>
              </div>
              <div id="ps-log-output" class="ps-log-output">
                <div class="ps-log-placeholder">Attached — waiting for output...</div>
              </div>
            </div>
            <div id="ps-telemetry-drawer" class="ps-telemetry-drawer collapsed">
              <div class="ps-telemetry-drawer-header">
                <div class="ps-telemetry-mode-toggle">
                  <button class="ps-tel-mode-btn active" data-mode="state">State</button>
                  <button class="ps-tel-mode-btn" data-mode="journal">Journal</button>
                </div>
                <button id="ps-telemetry-drawer-close" class="btn btn-icon" title="Collapse">✕</button>
              </div>
              <div class="ps-telemetry-drawer-body">
                <div class="ps-tel-filters">
                  <div class="ps-tel-filter-row ps-tel-filter-row-full">
                    <label>provider</label>
                    <div class="ps-picker-row" style="grid-column: span 2">
                      <button type="button" id="ps-tel-provider-picker" class="ps-input ps-input-sm ps-picker-display" title="Click to change"><em>Choose provider…</em></button>
                      <input type="hidden" id="ps-tel-providerid" value="" />
                    </div>
                  </div>
                  <div class="ps-tel-filter-row ps-tel-filter-row-full">
                    <label>entity</label>
                    <div class="ps-picker-row" style="grid-column: span 2">
                      <button type="button" id="ps-tel-entity-picker" class="ps-input ps-input-sm ps-picker-display" title="Click to change"><em>Choose device or user…</em></button>
                      <input type="hidden" id="ps-tel-entity-id" value="" />
                    </div>
                  </div>
                  <div class="ps-tel-filter-row ps-tel-filter-row-full">
                    <label>domain / message_type</label>
                    <div class="ps-picker-row" style="grid-column: span 2">
                      <button type="button" id="ps-tel-picker" class="ps-input ps-input-sm ps-picker-display" title="Click to change"><em>(any)</em></button>
                      <input type="hidden" id="ps-tel-domain" value="" />
                      <input type="hidden" id="ps-tel-mt" value="" />
                    </div>
                  </div>
                  <div class="ps-tel-range-chips" id="ps-tel-range-chips"></div>
                </div>
                <div class="ps-tel-actions">
                  <button id="ps-tel-refresh" class="btn btn-sm" title="Reload">↻</button>
                  <label class="ps-schema-editor-inline"><input type="checkbox" id="ps-tel-auto" /> Auto-refresh on log activity</label>
                  <span id="ps-tel-count" class="ps-tel-count"></span>
                </div>
                <div id="ps-tel-rows" class="ps-tel-rows">
                  <div class="ps-empty-state">Choose a provider and entity to load telemetry.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="ps-tab-stats" class="ps-tab-panel hidden">
          <div id="ps-stats-content" class="ps-stats-panel">
            <div class="ps-stats-placeholder">Loading stats…</div>
          </div>
        </div>
        <div id="ps-tab-config" class="ps-tab-panel hidden">
          <pre id="ps-config-content" class="ps-config-content"></pre>
        </div>
        <div id="ps-tab-test" class="ps-tab-panel hidden">
          <div class="ps-test-panel">
            <div class="ps-test-cases-bar">
              <button type="button" id="ps-test-case-select" class="ps-input ps-test-case-select ps-picker-display" title="Click to change"><em>(custom payload)</em></button>
              <input type="hidden" id="ps-test-case-name" value="" />
              <hs-toolbar-button id="ps-test-delete-btn" class="hidden" title="Delete"></hs-toolbar-button>
            </div>
            <div class="ps-test-desc hidden" id="ps-test-case-desc"></div>
            <div class="ps-test-input">
              <div class="ps-test-label">Test Payload (JSON)</div>
              <textarea id="ps-test-payload" class="ps-test-textarea" placeholder="Drop a JSON file here or paste a test payload..." spellcheck="false"></textarea>
            </div>
            <div class="ps-test-save-row">
              <span id="ps-test-editing-label" class="ps-test-editing-label">New test (unsaved)</span>
              <div class="ps-test-action-buttons">
                <hs-toolbar-button id="ps-test-save-btn" title="Save As…"></hs-toolbar-button>
                <button id="ps-test-run-btn" class="btn btn-primary">Run Test</button>
              </div>
            </div>
            <div id="ps-test-output" class="ps-test-output hidden">
              <div class="ps-test-label">Output</div>
              <pre id="ps-test-result" class="ps-test-result"></pre>
            </div>
          </div>
        </div>
        <div id="ps-tab-evidence" class="ps-tab-panel hidden">
          <div id="ps-evidence-panel" class="ps-evidence-panel"></div>
        </div>
      </div>
    </div>

    <!-- Scratch Pipeline Builder — minimal, throwaway/exploration only. Real features are
         authored by an IDE agent and imported as a feature bundle (see the Feature Bundle view). -->
    <div id="ps-form-view" class="ps-view hidden">
      <div class="ps-detail-header">
        <button id="ps-form-back-btn" class="btn btn-icon" title="Back to list">← Back</button>
        <span id="ps-form-title" class="ps-detail-name">Create Pipeline</span>
        <div class="ps-detail-actions" id="ps-form-quick-actions"></div>
        <div class="ps-detail-actions">
          <button id="ps-form-save-btn" class="btn btn-primary">Create</button>
        </div>
      </div>
      <div id="ps-form-result" class="ps-form-result hidden"></div>
      <div class="ps-builder-main">
        <div class="ps-form-body">
          <div id="ps-form-mode-notice" class="ps-scratch-notice">Scratch pipeline — no assertions or <code>rationale</code>, so it can never pass a <code>candidate</code> export. For a real feature, author it with an IDE agent and import it as a feature bundle instead.</div>
          <div class="ps-form-group">
            <label for="ps-form-name">Name<hs-help-icon key="pipeline.name"></hs-help-icon></label>
            <input type="text" id="ps-form-name" class="ps-input" placeholder="my-pipeline" />
            <span class="ps-form-hint">Alphanumeric, periods, hyphens, underscores. Must start/end with alphanumeric.</span>
          </div>
          <div class="ps-form-group">
            <label>Trigger Type<hs-help-icon key="pipeline.trigger"></hs-help-icon></label>
            <div class="ps-radio-group">
              <label><input type="radio" name="ps-trigger-type" value="events" checked /> Events</label>
              <label><input type="radio" name="ps-trigger-type" value="state" /> State change</label>
              <label><input type="radio" name="ps-trigger-type" value="pipeline" /> Pipeline</label>
              <label><input type="radio" name="ps-trigger-type" value="schedule" /> Schedule</label>
              <label><input type="radio" name="ps-trigger-type" value="api" /> API</label>
              <label><input type="radio" name="ps-trigger-type" value="kafka-events" /> Kafka events</label>
              <label><input type="radio" name="ps-trigger-type" value="kafka-raw" /> Kafka raw</label>
            </div>
          </div>
          <div id="ps-trigger-fields" class="ps-form-group"></div>
          <div class="ps-form-group">
            <label>Pipeline Steps
              <button type="button" id="ps-explain-pipeline-btn" class="btn btn-sm hidden" title="Walk through what this pipeline does, step by step">🔎 Walkthrough</button>
              <button type="button" id="ps-explain-concurrency-btn" class="btn btn-sm hidden" title="Explain concurrency & back-pressure for this pipeline">🔎 Concurrency</button>
            </label>
            <div id="ps-pipeline-steps" class="ps-pipeline-steps"></div>
            <div class="ps-add-step-row">
              <select id="ps-add-step-select" class="ps-input ps-input-sm"></select>
              <button type="button" id="ps-add-step-btn" class="btn btn-sm">+ Add step</button>
            </div>
          </div>
          <div class="ps-form-group ps-form-advanced hidden" id="ps-form-advanced">
            <label>Advanced Options</label>
            <div class="ps-form-row">
              <label for="ps-form-hwm">High Water Mark<hs-help-icon key="pipeline.highWaterMark"></hs-help-icon></label>
              <input type="number" id="ps-form-hwm" class="ps-input ps-input-sm" value="16" min="1" />
            </div>
            <div class="ps-form-row">
              <label><input type="checkbox" id="ps-form-serial" /> Serial Pipeline<hs-help-icon key="pipeline.serialPipeline"></hs-help-icon></label>
            </div>
          </div>
          <button id="ps-form-advanced-toggle" class="link-btn">Show advanced options</button>
        </div>
      </div>
    </div>

    <!-- Plugin Manager View -->
    <div id="ps-plugin-view" class="ps-view hidden">
      <div class="ps-detail-header">
        <button id="ps-plugin-back-btn" class="btn btn-icon" title="Back to list">← Back</button>
        <span class="ps-detail-name">Plugin Manager</span>
        <div class="ps-detail-actions">
          <button id="ps-plugin-refresh-btn" class="btn btn-icon" title="Refresh">⟳</button>
        </div>
      </div>
      <div class="ps-plugin-toolbar">
        <label for="ps-plugin-namespace">Developer namespace</label>
        <input type="text" id="ps-plugin-namespace" class="ps-input ps-input-sm" placeholder="Authenticated username" readonly />
        <div class="ps-upload-zone" id="ps-plugin-drop-zone">
          <span>Drop a .js plugin file here or</span>
          <button id="ps-plugin-upload-btn" class="btn btn-sm">Choose File</button>
          <input type="file" id="ps-plugin-file-input" accept=".js" class="hidden" />
        </div>
      </div>
      <div id="ps-subscriptions-section" class="ps-subscriptions-section hidden">
        <button type="button" id="ps-subscriptions-toggle" class="ps-subscriptions-summary">
          <span id="ps-subscriptions-count">Topic subscriptions: —</span>
          <span class="ps-subscriptions-caret">▾</span>
        </button>
        <div id="ps-subscriptions-detail" class="ps-subscriptions-detail hidden">
          <div class="ps-form-hint">Subscriptions are never dropped automatically — this keeps pipeline delete/restart instant. Unused topics just sit idle; reclaiming them is optional and only saves a little broker bandwidth.</div>
          <ul id="ps-subscriptions-list" class="ps-subscriptions-list"></ul>
          <hs-toolbar-button id="ps-subscriptions-prune-btn" title="Reclaim broker bandwidth"></hs-toolbar-button>
        </div>
      </div>
      <div id="ps-plugin-list" class="ps-plugin-list">
        <div class="ps-empty-state">Loading plugins...</div>
      </div>
    </div>
    <!-- Topology View -->
    <div id="ps-topology-view" class="ps-view hidden">
      <div class="ps-detail-header">
        <button id="ps-topology-back-btn" class="btn btn-icon" title="Back to list">← Back</button>
        <span class="ps-detail-name">Topology</span>
        <span id="ps-topology-ns" class="ps-ns-badge" title="Active namespace"></span>
        <div class="ps-detail-actions">
          <label class="ps-schema-editor-inline"><input type="checkbox" id="ps-topology-live-toggle" /> Live overlay (5s poll)</label>
          <button id="ps-topology-refresh-btn" class="btn btn-icon" title="Refresh">⟳</button>
        </div>
      </div>
      <div class="ps-topology-body">
        <div id="ps-topology-canvas" class="ps-topology-canvas">
          <div class="ps-empty-state">Loading topology…</div>
        </div>
      </div>
    </div>

    <!-- Prepare PR View -->
    <div id="ps-prepare-pr-view" class="ps-view hidden">
      <div class="ps-detail-header">
        <button id="ps-prepare-pr-back-btn" class="btn btn-icon" title="Back to list">← Back</button>
        <span class="ps-detail-name">Prepare PR</span>
        <span id="ps-prepare-pr-ns" class="ps-ns-badge" title="Active namespace"></span>
        <div class="ps-detail-actions">
          <button id="ps-prepare-pr-refresh-btn" class="btn btn-icon" title="Refresh">⟳</button>
        </div>
      </div>
      <div class="ps-prepare-pr-body" id="ps-prepare-pr-body">
        <div class="ps-empty-state">Loading…</div>
      </div>
    </div>

    <!-- Feature Bundle View -->
    <div id="ps-bundle-view" class="ps-view hidden">
      <div class="ps-detail-header">
        <button id="ps-bundle-back-btn" class="btn btn-icon" title="Back to list">← Back</button>
        <span class="ps-detail-name">Feature Bundle</span>
        <span id="ps-bundle-ns" class="ps-ns-badge" title="Active namespace"></span>
        <div class="ps-detail-actions">
          <button id="ps-bundle-capabilities-btn" class="btn btn-sm" data-label="Copy capability index" title="Copy the live capability index (GET /sandbox/capabilities) as JSON — paste into an IDE agent session that lags the deployment">Copy capability index</button>
        </div>
      </div>
      <div class="ps-bundle-body">
        <div class="ps-bundle-tabs">
          <button class="ps-bundle-tab active" data-bundle-tab="import">Import</button>
          <button class="ps-bundle-tab" data-bundle-tab="export">Export</button>
        </div>

        <!-- Import -->
        <div id="ps-bundle-tab-import" class="ps-bundle-tab-panel">
          <div class="ps-bundle-import-intro">
            Paste a feature bundle from your IDE agent — plain <code>elm.feature.bundle</code> or packed
            <code>gzip+base64</code>, auto-detected — or drop a <code>.feature.json</code> file. Plan is reviewed
            before anything is applied; the whole bundle is refused if any item is unsupported.
          </div>
          <div id="ps-bundle-drop-zone" class="ps-bundle-drop-zone">
            <textarea id="ps-bundle-import-text" class="ps-input ps-bundle-textarea" placeholder='{"kind": "elm.feature.bundle", ...}' spellcheck="false"></textarea>
          </div>
          <div class="ps-bundle-import-row">
            <label for="ps-bundle-import-ns">Target namespace</label>
            <input type="text" id="ps-bundle-import-ns" class="ps-input ps-input-sm" placeholder="namespace" />
            <label for="ps-bundle-import-mode">Mode</label>
            <select id="ps-bundle-import-mode" class="ps-input ps-input-sm">
              <option value="create">create (fail on conflict)</option>
              <option value="replace">replace (new version, retire old)</option>
            </select>
          </div>
          <div class="ps-bundle-import-actions">
            <button id="ps-bundle-validate-btn" class="btn btn-primary">Validate</button>
            <button id="ps-bundle-apply-btn" class="btn btn-primary" disabled title="Validate first">Import</button>
          </div>
          <div id="ps-bundle-plan-result" class="ps-bundle-result"></div>
        </div>

        <!-- Export -->
        <div id="ps-bundle-tab-export" class="ps-bundle-tab-panel hidden">
          <div class="ps-bundle-export-controls">
            <label for="ps-bundle-export-feature">Feature</label>
            <select id="ps-bundle-export-feature" class="ps-input ps-input-sm"></select>
            <label for="ps-bundle-export-policy">Policy</label>
            <select id="ps-bundle-export-policy" class="ps-input ps-input-sm" title="candidate refuses export unless every selected pipeline has passing evidence">
              <option value="candidate">candidate (refuses without passing evidence)</option>
              <option value="draft">draft (exports anything, flags unexercised)</option>
            </select>
            <button id="ps-bundle-export-refresh-btn" class="btn btn-icon" title="Refresh">⟳</button>
          </div>
          <div id="ps-bundle-export-items" class="ps-bundle-export-items">
            <div class="ps-empty-state">Loading…</div>
          </div>
          <div class="ps-bundle-import-row">
            <label for="ps-bundle-assign-feature-input">Assign feature label to checked items</label>
            <input type="text" id="ps-bundle-assign-feature-input" class="ps-input ps-input-sm" placeholder="feature name (blank = unassign)" />
            <button id="ps-bundle-assign-feature-btn" class="btn btn-sm">Apply</button>
          </div>
          <div class="ps-bundle-export-actions">
            <button id="ps-bundle-export-btn" class="btn btn-primary">Build export</button>
          </div>
          <div id="ps-bundle-export-result" class="ps-bundle-result"></div>
        </div>
      </div>
    </div>

    <!-- Schema Explorer View (v2 API) -->
    <div id="ps-schema-explorer-view" class="ps-view hidden">
      <div class="ps-detail-header">
        <button id="ps-schema-explorer-back-btn" class="btn btn-icon" title="Back to list">← Back</button>
        <span class="ps-detail-name">Schema Explorer</span>
        <span id="ps-schema-explorer-ns" class="ps-ns-badge" title="Active namespace"></span>
        <div class="ps-detail-actions">
          <button id="ps-schema-explorer-orphans-btn" class="btn btn-sm hidden" title="Namespaces with sandbox candidates but no active pipeline">Orphans <span id="ps-schema-explorer-orphans-count" class="ps-orphan-count">0</span></button>
          <button id="ps-schema-explorer-refresh-btn" class="btn btn-icon" title="Refresh">⟳</button>
        </div>
      </div>
      <div class="ps-schema-explorer-layout">
        <div class="ps-schema-explorer-col ps-schema-explorer-domains">
          <div class="ps-schema-explorer-col-header">Domains</div>
          <div id="ps-schema-explorer-domain-list" class="ps-schema-explorer-list">
            <div class="ps-empty-state">Loading…</div>
          </div>
        </div>
        <div class="ps-schema-explorer-col ps-schema-explorer-types">
          <div class="ps-schema-explorer-col-header">
            <span>Message Types</span>
            <div class="ps-schema-explorer-col-actions">
              <button id="ps-schema-explorer-new-btn" class="btn btn-sm" title="Create a new message_type in the selected domain">+ New</button>
            </div>
          </div>
          <div class="ps-schema-explorer-filter-row">
            <input id="ps-schema-explorer-filter" class="ps-input ps-input-sm" placeholder="filter…" />
          </div>
          <div id="ps-schema-explorer-common" class="ps-schema-explorer-common hidden">
            <div class="ps-schema-explorer-common-title">Common fields (auto-included)</div>
            <div id="ps-schema-explorer-common-chips" class="ps-schema-explorer-common-chips"></div>
          </div>
          <div id="ps-schema-explorer-type-list" class="ps-schema-explorer-list">
            <div class="ps-empty-state">Select a domain</div>
          </div>
        </div>
        <div class="ps-schema-explorer-col ps-schema-explorer-detail">
          <div class="ps-schema-explorer-col-header">
            <span id="ps-schema-explorer-detail-title">Details</span>
            <div class="ps-schema-explorer-col-actions" id="ps-schema-explorer-detail-actions"></div>
          </div>
          <div id="ps-schema-explorer-detail" class="ps-schema-explorer-detail-body">
            <div class="ps-empty-state">Select a message type</div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div id="ps-loading-overlay" class="ps-loading-overlay hidden"><span class="ps-spinner"></span></div>
</div>
`;
// Exports
export default code;